var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountUnverified(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "9px",
    viewBox: "0 0 9 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Account",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "M_Accounts_Overview_Unverified",
    transform: "translate(-136.000000, -545.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "np_x_1890803_000000",
    transform: "translate(136.000000, 545.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.49526486,4.49879653 L8.79395174,1.20099184 C9.06868275,0.926334298 9.06868275,0.480650698 8.79395174,0.205993156 C8.51922072,-0.0686643854 8.0734179,-0.0686643854 7.79868688,0.205993156 L4.5,3.50379784 L1.20131312,0.205993156 C0.926582103,-0.0686643854 0.480779277,-0.0686643854 0.206048261,0.205993156 C-0.0686827538,0.480650698 -0.0686827538,0.926334298 0.206048261,1.20099184 L3.50473514,4.49879653 L0.206048261,7.79660121 C-0.0686827538,8.07125875 -0.0686827538,8.51694235 0.206048261,8.79159989 C0.338598583,8.92411477 0.518921617,9 0.698865503,9 C0.878809389,9 1.05913242,8.93374067 1.19168275,8.79159989 L4.49994313,5.49379521 L7.79863001,8.79159989 C7.93118033,8.92411477 8.11150337,9 8.29144725,9 C8.47139114,9 8.65171417,8.93374067 8.78426449,8.79159989 C9.05899551,8.51694235 9.05899551,8.07125875 8.78426449,7.79660121 L5.49526486,4.49879653 Z",
    id: "Path"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountUnverified);
export default ForwardRef;